import root from 'window-or-global';

export const pageYOffset = () => root.pageYOffset;
